(function(){
'use strict';

PayPalSDK.$inject = ["cpAPI", "$http"];
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function PayPalSDK(cpAPI, $http) {
  var _this = this;

  this.paypal = null;
  this.paypalRecurring = null;
  this.billingAgreementToken = null;
  this.autosubmitPayPalCommerceHandler = null;
  this.isInit = false;
  this.isPayPalCommerceSubmission = false;

  this.init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$commit = _ref2.commit,
        commit = _ref2$commit === undefined ? true : _ref2$commit;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (_this.isInit) {
              _context2.next = 3;
              break;
            }

            _context2.next = 3;
            return cpAPI.getPayPalCommerceData('USD').then(function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
                var merchantId, clientId, config, configRecurring;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        merchantId = data.merchantId, clientId = data.clientId;


                        _this.merchantId = merchantId;

                        config = {
                          components: 'buttons,funding-eligibility',
                          'enable-funding': 'venmo',
                          currency: 'USD',
                          'client-id': clientId,
                          'merchant-id': merchantId,
                          commit: commit,
                          'data-namespace': 'paypal'
                        };
                        configRecurring = {
                          components: 'buttons,funding-eligibility',
                          currency: 'USD',
                          'client-id': clientId,
                          'data-namespace': 'paypalRecurring',
                          intent: 'tokenize',
                          vault: true
                        };

                        if (!(typeof window.paypalLoadScript === 'undefined')) {
                          _context.next = 7;
                          break;
                        }

                        _context.next = 7;
                        return loadScript('https://unpkg.com/@paypal/paypal-js@4.0.8/dist/iife/paypal-js.legacy.min.js');

                      case 7:
                        _context.next = 9;
                        return window.paypalLoadScript(config).then(function (paypal) {
                          _this.paypal = paypal;
                        });

                      case 9:
                        _context.next = 11;
                        return window.paypalLoadScript(configRecurring).then(function (paypalRecurring) {
                          _this.paypalRecurring = paypalRecurring;
                          _this.isInit = true;
                        });

                      case 11:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function (_x2) {
                return _ref3.apply(this, arguments);
              };
            }());

          case 3:
            return _context2.abrupt('return', {
              paypal: _this.paypal,
              paypalRecurring: _this.paypalRecurring,
              merchantId: _this.merchantId
            });

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  this.createOrder = function (amount, currency, paymentMethod) {
    return cpAPI.createPayPalOrder(amount, currency, paymentMethod).then(function (order) {
      return order.orderId;
    });
  };

  this.createBillingAgreementToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return cpAPI.getPayPalBillingAgreementToken().then(function (_ref5) {
              var billingAgreementToken = _ref5.billingAgreementToken;

              _this.billingAgreementToken = billingAgreementToken;
            });

          case 2:
            return _context3.abrupt('return', _this.billingAgreementToken);

          case 3:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  this.getBillingAgreementToken = function () {
    return _this.billingAgreementToken;
  };

  this.getBillingAgreementTokenDetails = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(baToken) {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', $http({
                url: '/frs-api/getPayPalBillingAgreementTokenDetails',
                method: 'GET',
                params: {
                  baToken: baToken
                }
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x3) {
      return _ref6.apply(this, arguments);
    };
  }();

  this.getOrderDetails = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(orderID) {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', $http({
                url: '/frs-api/getOrderDetails',
                method: 'GET',
                params: {
                  orderID: orderID
                }
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function (_x4) {
      return _ref7.apply(this, arguments);
    };
  }();

  this.setAutoSubmitPayPalCommerceHandler = function (handler) {
    _this.autosubmitPayPalCommerceHandler = handler;
  };

  this.autosubmitPayPalCommerce = function () {
    if (!_this.isInit || _this.autosubmitPayPalCommerceHandler === null) {
      return;
    }
    _this.isPayPalCommerceSubmission = true;
    _this.autosubmitPayPalCommerceHandler();
  };

  var loadScript = function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      var r = false;
      s.type = 'text/javascript';
      s.src = src;
      s.async = true;
      s.onerror = function (err) {
        reject(err, s);
      };
      // eslint-disable-next-line no-multi-assign
      s.onload = s.onreadystatechange = function () {
        if (!r && (!this.readyState || this.readyState == 'complete')) {
          r = true;
          resolve();
        }
      };
      var t = document.getElementsByTagName('script')[0];
      t.parentElement.insertBefore(s, t);
    });
  };
}

angular.module('classy').service('PayPalSDK', PayPalSDK);
})();